import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import agentsRoutes from "./agents";
import galaxyRoutes from "./galaxy";
import emailsRoutes from "./email";
import mailboxRoutes from "./mailbox";
import toolsRoutes from "./tools";
import cmsRoutes from "./cms";
import financeRoutes from "./finance";
import miscRoutes from "./miscellaneous";
import eventsRoutes from "./events";
import conferenceArchiveRoutes from "./conference-archive";
import conferenceRoutes from "./conference";
import payrollRoutes from "./payroll";
import billingRoutes from "./billing";

const Home = lazy(() => import("@/pages/admin/Home"));
const AllChangelogs = lazy(() => import("@/pages/admin/changelogs/Changelogs"));

const adminRoutes: RouteObject[] = [
  { index: true, element: <Home /> },
  { path: "agents", children: agentsRoutes },
  { path: "galaxy", children: galaxyRoutes },
  { path: "email", children: emailsRoutes },
  { path: "mailbox", children: mailboxRoutes },
  { path: "tools", children: toolsRoutes },
  { path: "cms", children: cmsRoutes },
  { path: "finance", children: financeRoutes },
  { path: "billing", children: billingRoutes },
  { path: "payroll", children: payrollRoutes },
  { path: "miscellaneous", children: miscRoutes },
  { path: "changelogs", element: <AllChangelogs /> },
  { path: "events", children: eventsRoutes },
  { path: "conference", children: conferenceRoutes },
  { path: "conference-archive", children: conferenceArchiveRoutes },
];

export default adminRoutes;
